// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const DocumentationIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M10.44 21.56q.73.42 1.56.43.83 0 1.56-.42c1.4-.8 3.58-1.8 6.02-1.98 1.64-.1 2.92-1.45 2.92-3.07V5.1c0-.87-.37-1.7-1.02-2.28-.66-.59-1.54-.87-2.42-.77C16.53 2.3 14.37 3.3 13 4.1c-.62.36-1.4.36-2.02 0-1.36-.8-3.52-1.8-6.04-2.07-.88-.1-1.77.18-2.43.77-.64.6-1.01 1.42-1.01 2.3v11.43c0 1.62 1.28 2.97 2.92 3.07 2.44.18 4.62 1.17 6.02 1.97"
        opacity=".5"
      />
      <path
        fillRule="evenodd"
        d="M12 17.7c-.46 0-.83-.38-.83-.83V9.4c0-.46.37-.83.83-.83s.83.37.83.83v7.46c0 .45-.37.82-.83.82"
      />
    </g>
  </SvgIcon>
);

export default DocumentationIcon;
